module.exports = __webpack_public_path__ + "1e6344d71aacb06dc865d7ad86f7cdc6.svg";